module.exports = __webpack_public_path__ + "static/digilege_screen-9d572f1dfc31c48aa5bf68f45de42bd3.jpg";